module.exports = __webpack_public_path__ + "img/15053254000498.a580fe31.png";